import React from "react"
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Table,
  Button,
  Row,
  Col,
} from "reactstrap"

const OrderModal = ({ isOpen, toggle, orderData = {}, modalType }) => {
  const chargeableItems =
    orderData.productIdsAndQty?.filter(item => item?.isChargeable) || []

  const nonChargeableItems =
    orderData.productIdsAndQty?.filter(item => !item?.isChargeable) || []

  const totalChargeableAmount = chargeableItems.reduce(
    (sum, item) => sum + Number(item.price * item.qty || 0),
    0
  )

  const totalNonChargeableAmount = nonChargeableItems.reduce(
    (sum, item) => sum + Number(item.price * item.qty || 0),
    0
  )

  const grandTotal = totalChargeableAmount + totalNonChargeableAmount

  const renderTable = (title, items, total, badgeColor) => (
    <Col xl={6}>
      <h5 className="mt-3 mb-2 fw-bold text-dark">
        {title} <span className={`badge bg-${badgeColor}`}>{items.length}</span>
      </h5>

      <Table bordered responsive className="mb-4 bg-light">
        <thead className="bg-blue text-white">
          <tr>
            <th>#</th>
            <th>Product</th>
            <th className="text-end">Price</th>
            <th className="text-center">Qty</th>
            <th className="text-end">Total</th>
          </tr>
        </thead>
        <tbody>
          {items.length === 0 ? (
            <tr>
              <td colSpan={5} className="text-center py-3">
                No products found
              </td>
            </tr>
          ) : (
            items.map((item, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{item.productName}</td>
                <td className="text-end">£{Number(item.price).toFixed(2)}</td>
                <td className="text-center">{item.qty}</td>
                <td className="text-end">
                  £{Number(item.price * item.qty).toFixed(2)}
                </td>
              </tr>
            ))
          )}

          <tr className="fw-bold">
            <td colSpan={4} className="text-end">
              Total
            </td>
            <td className="text-end">£{total.toFixed(2)}</td>
          </tr>
        </tbody>
      </Table>
    </Col>
  )

  return (
    <Modal isOpen={isOpen} size="xl">
      <ModalHeader toggle={toggle}>
        Order Details – {orderData.orderId}
      </ModalHeader>

      <ModalBody>
        <Row>
          {/* CHARGEABLE PRODUCTS */}
          {renderTable(
            "Chargeable Products",
            chargeableItems,
            totalChargeableAmount,
            "success"
          )}

          {/* NON-CHARGEABLE PRODUCTS */}
          {renderTable(
            "Non-Chargeable Products",
            nonChargeableItems,
            totalNonChargeableAmount,
            "warning"
          )}
        </Row>

        {/* GRAND TOTAL */}
        <div className="text-end fw-bold fs-5 mt-3">
          Grand Total: £{grandTotal.toFixed(2)}
        </div>

        {/* REMARKS */}
        {orderData.remark && (
          <div className="mt-4">
            <h6>Remarks</h6>
            <p className="text-muted">{orderData.remark}</p>
          </div>
        )}
      </ModalBody>

      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default OrderModal
